
import { faviconLinks } from "@utils";
export default {
	head() {
		return {
			title: this.$t(this.$route.meta.title),
			meta: [
				{
					hid: "description",
					name: "description",
					content: this.$t(this.$route.meta.description),
				},
			],
			link: faviconLinks({ isBlueBranding: this.$isBlueBranding }),
		};
	},
};
